import Joi from "joi";
export const addTransferSchema = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      customer_id: null,
      totalAmount: null,

      feesRates: null,
      currency: null,
      NB: "",
    },
    schema: Joi.object({
      customer_id: Joi.number().required().messages({
        "number.empty": joiMessage.common.required,
        "number.base": joiMessage.create_transfer.customer_id.invalid,
      }),
      totalAmount: Joi.number().integer().positive().required().messages({
        "number.empty": joiMessage.common.required,
        "number.base": joiMessage.create_transfer.amount.invalid,
        "number.positive": joiMessage.create_transfer.amount.positve_number,
        "number.integer": joiMessage.create_transfer.amount.invalid,
      }),

      feesRates: Joi.number().min(0).required().messages({
        "number.empty": joiMessage.common.required,
        "number.base": joiMessage.create_transfer.fees.invalid,
        "number.min": joiMessage.create_transfer.fees.positve_number,
      }),
      currency: Joi.string().valid("840", "156").required().messages({
        "string.empty": joiMessage.common.required,
        "string.base": joiMessage.create_transfer.currency.invalid,
        "string.only": joiMessage.create_transfer.currency.only,
      }),
      NB: Joi.string().allow("").optional().min(0).max(254).messages({
        "string.empty": joiMessage.common.required,
        "string.base": joiMessage.create_transfer.notes.invalid,
        // "string.min": joiMessage.create_transfer.notes.min,
        "string.max": joiMessage.create_transfer.notes.max,
      }),
    }),
    explicitCheck: {
      customer_id: false,
      totalAmount: false,
      feesRates: false,
      currency: false,
      NB: false,
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};

export const updateTransferSchema = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      totalAmount: null,
      feesRates: null,
      currency: null,
      NB: "",
    },
    schema: Joi.object({
      totalAmount: Joi.number()
        .allow(null, "", NaN)
        .integer()
        .positive()
        .optional()
        .messages({
          "number.base": joiMessage.create_transfer.amount.invalid,
          "number.positive": joiMessage.create_transfer.amount.positve_number,
          "number.integer": joiMessage.create_transfer.amount.invalid,
        }),

      feesRates: Joi.number().allow(null, "", NaN).min(0).optional().messages({
        "number.empty": joiMessage.common.required,
        "number.base": joiMessage.create_transfer.fees.invalid,
        "number.min": joiMessage.create_transfer.fees.positve_number,
      }),
      currency: Joi.string()
        .allow(null, "")
        .valid("840", "156")
        .optional()
        .messages({
          "string.base": joiMessage.create_transfer.currency.invalid,
          "string.only": joiMessage.create_transfer.currency.only,
        }),
      NB: Joi.string().allow(null, "").optional().min(1).max(254).messages({
        "string.base": joiMessage.create_transfer.notes.invalid,
        "string.min": joiMessage.create_transfer.notes.min,
        "string.max": joiMessage.create_transfer.notes.max,
      }),
    }),
    explicitCheck: {
      totalAmount: false,
      feesRates: false,
      currency: false,
      NB: false,
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};

export const withdrawTransferSchema = (lang) => {
  const language = lang === "AR" ? "arabic" : "english";
  const joiMessage = require(`../../translate/${language}/joi.json`);

  const schema = {
    initialData: {
      action: null,
    },
    schema: Joi.object({
      action: Joi.string().valid("WITHDRAWN", "CANCELED").required().messages({
        "string.empty": joiMessage.common.required,
        "string.base": joiMessage.create_transfer.withdraw_select.invalid,
        "string.only": joiMessage.create_transfer.withdraw_select.only,
      }),
    }),
    explicitCheck: {
      action: false,
    },
    validationOptions: {
      abortEarly: true,
    },
  };
  return { schema: schema };
};
